import Parse from "parse";

//***** Google Sheet { *****//
export const saveToSheet = async ({
  keyCode,
  introInCode,
  introTeam,
  playerName,
  userRole,
  score,
  suspectScore,
  clearTime,
  teamRank,
  survey1,
  survey2,
  survey3,
  survey4,
  survey5,
  survey6,
  survey7,
}) => {
  // undefined인 값은 제외하고 전송
  const params = { keyCode };
  if (introInCode !== undefined) params.introInCode = introInCode;
  if (introTeam !== undefined) params.introTeam = introTeam;
  if (playerName !== undefined) params.playerName = playerName;
  if (userRole !== undefined) params.userRole = userRole;
  if (score !== undefined) params.score = score;
  if (suspectScore !== undefined) params.suspectScore = suspectScore;
  if (clearTime !== undefined) params.clearTime = clearTime;
  if (teamRank !== undefined) params.teamRank = teamRank;
  if (survey1 !== undefined) params.survey1 = survey1;
  if (survey2 !== undefined) params.survey2 = survey2;
  if (survey3 !== undefined) params.survey3 = survey3;
  if (survey4 !== undefined) params.survey4 = survey4;
  if (survey5 !== undefined) params.survey5 = survey5;
  if (survey6 !== undefined) params.survey6 = survey6;
  if (survey7 !== undefined) params.survey7 = survey7;

  return await Parse.Cloud.run("appendToSheet_spyx", params);
};
//***** } Google Sheet *****//
